import { render } from "./sims.vue?vue&type=template&id=5d746a67"
import script from "./sims.vue?vue&type=script&lang=js"
export * from "./sims.vue?vue&type=script&lang=js"

import "./sims.vue?vue&type=style&index=0&id=5d746a67&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__